<template>
  <div v-if="opqIf">
    <infobulle :descriptionPopup="descriptionPopup">
      <div v-html="libelleLong" class="mb-1"></div>
      <div class="date-fields">
        <v-autocomplete
          v-if="!hideDay"
          v-bind="$attrs"
          v-model="day"
          :items="days.filter((d) => d.value <= daysInMonth(month, year))"
          label="Jour"
          style="width: 100px"
          class="flex-grow-0 mr-2 mb-2 mb-sm-0"
          @input="handleChange"
          @blur="handleBlur"
          :rules="dayRules"
          outlined
          dense
          :loading="updating"
          :disabled="updating || disabled"
          auto-select-first
          :error="!conditionRespectee"
        ></v-autocomplete>

        <v-autocomplete
          v-bind="$attrs"
          v-model="month"
          :items="months"
          label="Mois"
          style="width: 140px"
          class="flex-grow-0 mr-2 mb-2 mb-sm-0"
          @input="handleChange"
          @blur="handleBlur"
          :rules="monthRules"
          outlined
          dense
          :loading="updating"
          :disabled="updating || disabled"
          auto-select-first
          :error="!conditionRespectee"
        ></v-autocomplete>
        <v-autocomplete
          v-bind="$attrs"
          v-model="year"
          :items="years"
          label="Année"
          style="width: 100px"
          class="flex-grow-0"
          @input="handleChange"
          @blur="handleBlur"
          :rules="yearRules"
          outlined
          dense
          :loading="updating"
          :disabled="updating || disabled"
          auto-select-first
          :error="!conditionRespectee"
        ></v-autocomplete>
        <v-btn v-if="valid && !disabled" icon text class="ml-1" @click="clear"><v-icon>mdi-close</v-icon></v-btn>
      </div>
      <div v-if="!conditionRespectee" class="error--text mt-n2">{{ conditionMessage }}</div>
      <v-checkbox class="list_counter_validator my-2 ml-6 p-0" :input-value="conditionRespectee" :rules="[(v) => optional || !!v]"></v-checkbox>
    </infobulle>
  </div>
</template>

<script>
import ChampBase from "@/mixins/ChampBase"
import { Api, Queue } from "@/plugins/api"

// @group Champs
export default {
  mixins: [ChampBase],

  props: {
    code: { type: String, required: true },
    isBirthdate: { type: Boolean, default: false },
    hideDay: Boolean,
    live: { type: Object },
    maxYear: {
      type: Number,
      default: null
    },

    minYear: {
      type: Number,
      default: null
    },
    optional: Boolean,
    value: {
      type: String
    },
    opqIf: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    condition: { type: Function, required: false },
    conditionMessage: { type: String }
  },

  data() {
    return {
      year: null,
      month: null,
      day: null,
      years: [],
      months: [],
      days: [],
      updating: false
    }
  },

  created() {
    this.setYears()
    this.months.push({ text: "Janvier", value: "01" })
    this.months.push({ text: "Février", value: "02" })
    this.months.push({ text: "Mars", value: "03" })
    this.months.push({ text: "Avril", value: "04" })
    this.months.push({ text: "Mai", value: "05" })
    this.months.push({ text: "Juin", value: "06" })
    this.months.push({ text: "Juillet", value: "07" })
    this.months.push({ text: "Aout", value: "08" })
    this.months.push({ text: "Septembre", value: "09" })
    this.months.push({ text: "Octobre", value: "10" })
    this.months.push({ text: "Novembre", value: "11" })
    this.months.push({ text: "Décembre", value: "12" })

    for (let j = 1; j <= 31; j++) {
      this.days.push({
        text: j,
        value: j < 10 ? "0" + j.toString() : j.toString()
      })
    }
    this.setValues(this.value)
  },

  computed: {
    minYearInner() {
      if (this.minYear) {
        return this.minYear
      }
      if (this.isBirthdate) {
        return new Date().getFullYear() - 100
      }
      return 2000
    },
    maxYearInner() {
      if (this.maxYear) {
        return this.maxYear
      }
      if (this.isBirthdate) {
        return new Date().getFullYear() - 15
      }
      return new Date().getFullYear() + 6
    },
    yearRules() {
      return [(v) => this.optional || this.years.indexOf(v) > -1 || "Année"]
    },
    monthRules() {
      return [(v) => this.optional || this.months.map((m) => m.value).indexOf(v) > -1 || "Mois"]
    },
    dayRules() {
      return [(v) => this.hideDay || this.optional || this.days.map((d) => d.value).indexOf(v) > -1 || "Jour"]
    },
    valid() {
      return this.$dateRegex.test(this.stringValue)
    },
    stringValue() {
      if (this.year == null && this.month == null && this.day == null) {
        return null
      }
      return `${this.year}-${this.month}-${this.hideDay ? "01" : this.day}`
    },
    conditionRespectee() {
      if (typeof this.condition == "function") {
        return this.condition(this.stringValue)
      }
      return true
    }
  },

  methods: {
    daysInMonth(month, year) {
      return new Date(year, month, 0).getDate()
    },
    setYears() {
      this.years = []
      for (let a = this.minYearInner; a < this.maxYearInner; a++) {
        this.years.push(a.toString())
      }
    },
    handleChange() {
      let day = Math.min(parseInt(this.day), this.daysInMonth(this.month, this.year)).toString()
      this.day = day < 10 ? "0" + day : day
      if (this.valid) {
        this.$emit("input", this.stringValue)
      }
    },
    handleBlur(priority = 1) {
      // On enregistre toute date bien formée, même hors plage : la condition bloque
      // la soumission (checkbox de validation) mais ne doit pas empêcher la sauvegarde,
      // sinon la valeur saisie est perdue silencieusement et la fiche arrive sans date.
      if (this.valid) {
        if (this.live) {
          this.updating = true
          Queue.enqueue(
            () =>
              Api.post(this.live.endpoint, {
                fileId: this.live.fileId,
                cle: this.live.cle,
                value: this.stringValue
              }).finally(() => {
                this.updating = false
              }),
            priority
          )
        }
      }
    },
    setValues(value) {
      if (value) {
        let match = value.match(/([0-9]{4})-([0-9]{2})-([0-9]{2})/)
        if (match) {
          this.year = match[1]
          this.month = match[2]
          this.day = match[3]
        }
      }
    },
    clear() {
      this.day = null
      this.month = null
      this.year = null
      if (this.live) {
        Queue.enqueue(() =>
          Api.post(this.live.endpoint, {
            fileId: this.live.fileId,
            cle: this.live.cle,
            value: null
          }).finally(() => {
            this.updating = false
          })
        )
      }
      this.$emit("input", null)
    },
    setValue(date) {
      let stringDate = date.toLocaleDateString("fr-CA")
      this.setValues(stringDate)
      this.handleBlur(8)
      this.handleChange()
    },
    setValueToToday() {
      let today = new Date()
      this.setValue(today)
    }
  },

  watch: {
    opqIf(newValue) {
      if (!newValue) {
        this.clear()
      }
    }
  }
}
</script>

<style>
@media screen and (min-width: 380px) {
  .date-fields {
    display: flex;
  }
}
</style>